import { useState, useEffect } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { useNavigate } from 'react-router-dom';
import { auth, db } from '../../services/firebase';
import { doc, getDoc } from 'firebase/firestore';

export const useSellerOnboarding = () => {
  const [user, authLoading] = useAuthState(auth);
  const [sellerStatus, setSellerStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const checkSellerStatus = async () => {
      if (!user) return;

      try {
        const userRef = doc(db, 'users', user.uid);
        const userSnap = await getDoc(userRef);
        
        if (userSnap.exists()) {
          const userData = userSnap.data();
          const status = userData.sellerStatus || 'not_started';
          setSellerStatus(status);
        } else {
          setSellerStatus('not_started');
        }
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };

    if (user && !authLoading) {
      checkSellerStatus();
    } else if (!authLoading) {
      setLoading(false);
    }
  }, [user, authLoading]);

  const handleSellerOnboardingComplete = () => {
    // Refresh seller status or redirect
    navigate('/seller-dashboard');
  };

  // Determine redirect conditions
  // CRITICAL: Check email verification using hostname check, not env var
  const isLocalhost = typeof window !== 'undefined' && window.location.hostname === 'localhost';
  const shouldRedirectToLogin = (!user && !authLoading && !loading) || 
    (user && !user.emailVerified && !isLocalhost && !authLoading && !loading);
  // Only redirect to dashboard if seller has completed onboarding AND has active status
  const shouldRedirectToDashboard = sellerStatus === 'active' && !loading;

  return {
    user,
    authLoading,
    sellerStatus,
    loading,
    handleSellerOnboardingComplete,
    shouldRedirectToLogin,
    shouldRedirectToDashboard
  };
};